import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../css/NmapX.css';
import { faFileCsv, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const NmapX = () => {
    const [visitors, setVisitors] = useState([]);

    // Define baseUrl and token at the component level so they're accessible in all functions
    const token = localStorage.getItem('token');
    const baseUrl = process.env.NODE_ENV === 'production'
        ? process.env.REACT_APP_API_BASE_URL
        : process.env.REACT_APP_LOCAL_API_BASE_URL;

    useEffect(() => {
        axios.get(`${baseUrl}/api/visitors`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        .then((response) => setVisitors(response.data))
        .catch((error) => console.error("Error fetching visitor data:", error));
    }, [baseUrl, token]);

    const downloadCSV = async () => {
        try {
            const response = await axios.get(`${baseUrl}/api/visitors/csv`, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'visitors.csv');
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Error downloading CSV:', error);
        }
    };

    const downloadExcel = async () => {
        try {
            const response = await axios.get(`${baseUrl}/api/visitors/excel`, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'visitors.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Error downloading Excel:', error);
        }
    };

    return (
        <div className="nmapx-container">
            <h2>Visitor Information</h2>
            <div className="export-buttons">
                <button onClick={downloadCSV}>
                    <FontAwesomeIcon icon={faFileCsv} /> Download CSV
                </button>
                <button onClick={downloadExcel}>
                    <FontAwesomeIcon icon={faFileExcel} /> Download Excel
                </button>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>IP Address</th>
                        <th>City</th>
                        <th>Region</th>
                        <th>Country</th>
                        <th>Location</th>
                        <th>Timestamp</th>
                    </tr>
                </thead>
                <tbody>
                    {visitors.map((visitor) => (
                        <tr key={visitor._id}>
                            <td>{visitor.ip}</td>
                            <td>{visitor.city}</td>
                            <td>{visitor.region}</td>
                            <td>{visitor.country}</td>
                            <td>{visitor.loc}</td>
                            <td>{new Date(visitor.timestamp).toLocaleString()}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default NmapX;
